import React from 'react';
import { Box } from '@mui/material';
import EditableStandardVendorName from './EditableStandardVendorName';
import ApproveChangeTicket from './ApproveChangeTicket';
import RejectChangeTicket from './RejectChangeTicket';
import RevertRejection from './RevertRejection';
import { VendorChangeTicketEntry } from '../../types/vendor-types';

interface VendorChangeTicketCellsProps {
  ticket: VendorChangeTicketEntry;
}

/**
 * Renders the standard vendor name - either editable (for pending) or display-only
 */
export const StandardVendorNameCell: React.FC<VendorChangeTicketCellsProps> = ({ ticket }) => {
  if (ticket.status === 'pending') {
    return (
      <EditableStandardVendorName
        ticketId={ticket.id}
        currentValue={ticket.standard_vendor_name}
        discoveredValue={ticket.normalized_vendor_name}
      />
    );
  }
  return <>{ticket.standard_vendor_name || '-'}</>;
};

/**
 * Renders the action buttons based on ticket status
 */
export const TicketActionsCell: React.FC<VendorChangeTicketCellsProps> = ({ ticket }) => {
  if (ticket.status === 'pending') {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 0.5 }}>
        <ApproveChangeTicket
          ticketId={ticket.id}
          vendorName={ticket.normalized_vendor_name}
          standardVendorName={ticket.standard_vendor_name}
        />
        <RejectChangeTicket
          ticketId={ticket.id}
          vendorName={ticket.normalized_vendor_name}
        />
      </Box>
    );
  }

  if (ticket.status === 'rejected') {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 0.5 }}>
        <RevertRejection
          ticketId={ticket.id}
          vendorName={ticket.normalized_vendor_name}
        />
      </Box>
    );
  }

  return null;
};
